import { makeStyles, Theme } from '@material-ui/core';

export const useStxsStyles = makeStyles<Theme>((theme) => ({
  stxsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    aligIitems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('xs')]: {},
  },
  stxsHeader: {
    display: 'grid',
    alignItems: 'center',
    // gridTemplateColumns: '25% 25% 30% 20%',
    gridTemplateColumns: '50% 50%',
    color: '#949494',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '26px',
    [theme.breakpoints.down('sm')]: {},
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },

    '& > span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: 1,
    },
    '& > span:last-child': {
      justifySelf: 'flex-end',
    },
  },
  tableRow: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '50% 50%',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
    padding: '18px 0',
    minHeight: '86px',
    borderBottom: '1px solid #323235',

    '& > div:last-child': {
      justifySelf: 'flex-end',
      [theme.breakpoints.down('xs')]: {
        justifySelf: 'center',
      },
    },

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      rowGap: '8px',
    },

    [theme.breakpoints.down('xs')]: {},
  },
  domainName: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '6px',
    },
  },
  rowTableIcon: {
    background: '#43464D',
    width: '36px',
    height: '36px',
    borderRadius: '18px',
    padding: '7px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  itemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  sendBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  ownerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      gap: '6px',
    },
  },
  itemColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  caption: {
    color: '#FAFAFA',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
    '& > span': {
      color: '#ABABAB',
      fontSize: '14px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
  },
  title: {
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  value: {
    color: '#949494',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  noDataWrapper: {
    width: '100%',
    maxWidth: '384px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));
